import { createSlice } from '@reduxjs/toolkit';
import { fetchCheckPay } from '../action/checkPaymentAction';
const initialState = {
    checkPay: [],
    checkPay2: [],
    settings: [],
    isLoader: false
};
export const checkPaySlice = createSlice({
    initialState,
    name: 'checkPay',
    reducers: {},
    extraReducers: {
        [fetchCheckPay.fulfilled.type]: (state, action) => {
            var _a;
            state.checkPay2 = action.payload[0];
            state.checkPay = action.payload[1];
            // Третьим набором приходят настройки вуза: по ним меню решает,
            // показывать ли разделы платной основы.
            state.settings = (_a = action.payload[2]) !== null && _a !== void 0 ? _a : [];
            state.isLoader = false;
        },
        [fetchCheckPay.pending.type]: (state) => {
            state.isLoader = true;
        }
    }
});
export default checkPaySlice.reducer;
